import React from 'react';
import {
  Grid,
  TextField
} from '@material-ui/core';
import { InfoTooltip } from 'components';


const TextFieldGrid = ({
  name,
  label,
  value,
  onChange,
  InputProps = {},
  classes = '',
  isTooltip = false,
  tooltipTitle
}) => {
  return (
    <Grid container spacing={3} className="ml-2 mb-5 items-center">
      <Grid item xs={12} md={3}>
        {label}
      </Grid>
      <Grid item xs={12} md={8} lg={6} className="text-right flex">
        <TextField
          variant="outlined"
          color="primary"
          fullWidth
          className={classes}
          name={name}
          label={label}
          value={value}
          InputProps={InputProps}
          onChange={(event) => onChange(event.target.value)}
        />
        {isTooltip &&
          <InfoTooltip title={tooltipTitle} />
        }
      </Grid>
    </Grid>
  );
};

export default TextFieldGrid;
